import { Injectable } from '@angular/core';
import { Http, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { ModelService } from './model.service';
import { App } from 'ionic-angular';
import { BeneficiaireListPage } from '../../pages/beneficiaire-list/beneficiaire-list';
import { LoadingService } from './loading.service';
import { ToolsService } from './tools.service';

@Injectable()
export class HttpInterceptorService extends Http {

  public isMsgErrorActif: boolean = false;

  constructor(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    private modelService: ModelService,
    private app: App,
    private loadingService: LoadingService,
    private tools: ToolsService,
  ) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (url instanceof Request && url.headers.get('content-type') === 'image/*') {
      // On ne traite pas les erreurs sur les images
      return super.request(url, options);
    } else {
      return super.request(url, options).do(this.catchAuthError(this)).catch(this.catchAuthError(this));
    }
  }

  private catchAuthError(self: HttpInterceptorService) {
    let message = 'Vous n\'êtes pas autorisé à accéder cette page';

    return (res: any) => {
      switch (res.status) {
        case 413: {
          this.afficheMessageError('Le fichier fourni est trop volumineux, veuillez fournir un fichier inférieur à 5 Mo.', 'error');
          // this.tools.toast.createAdv({
          //   message: 'Le fichier fourni est trop volumineux, veuillez fournir un fichier inférieur à 5 Mo.',
          //   type: 'error'
          // });
          this.loadingService.end();
          break;
        }
        case 401: {
          if (
            false === res.url.includes('/payment/capture/') &&
            false === res.url.includes('/paiements/done')
          ) {
            this.modelService.logOut(this.app);
            this.afficheMessageError('Votre session a expiré, veuillez vous reconnecter', 'error')
            // if (!this.isMsgErrorActif) {
            //   this.tools.toast.create('Vous avez été déconnecté');
            //   this.setMessageErrorActif();
            // }
          }
          this.loadingService.end();
          break;
        }
        case 403: {
          const contentType = res.headers && res.headers.get('Content-Type');
          const isJson = contentType && contentType.indexOf('application/json') !== -1;

          if (res && res._body && isJson && res.json().message === 'invalid version') {
            this.afficheMessageError("IMPORTANT : Une nouvelle version de l’application est disponible sur le store.\n" +
              "Votre version actuelle n’est plus compatible et doit absolument être mise à jour avant toute nouvelle utilisation.\n" +
              "Merci de mettre à jour PocKet'CE.",
              "error");
          } else if (res && res._body && isJson && res.json().message) {
            this.afficheMessageError(res.json().message, "error");
          } else {
            this.afficheMessageError("Vous n\'êtes pas autorisé à accéder cette page", "error");
            // this.tools.toast.createAdv({message: 'Vous n\'êtes pas autorisé à accéder cette page', type: 'error'});
          }
          this.loadingService.end();
          break;
        }
        case 404: {
          if (!(res.url.includes('/getCGV') || res.url.includes('/getStatutReducce'))) {
            if ('error' in res && 'error' in res.error && 'message' in res.error.error && res.error.error.message) {
              message = res.error.error.message;
            } else {
              message = 'Oups, une erreur est survenue, veuillez réessayer dans quelques minutes ou contacter votre administrateur. [CD404]';
            }

            this.app.getRootNav().setRoot(BeneficiaireListPage);
            this.afficheMessageError(message, "error");
            // this.tools.toast.createAdv({message, type: 'error'});
            this.loadingService.end();
          }
          break;

        }
        case 410: {
          if (
            false !== res.url.includes('/checkout') ||
            false !== res.url.includes('/commandes')
          ) {
            message = JSON.parse(res._body).message;
          } else {
            message = 'Oups, une erreur est survenue, veuillez réessayer dans quelques minutes ou contacter votre administrateur. [CD410]';
          }
          this.app.getRootNav().setRoot(BeneficiaireListPage);
          this.loadingService.end();
          break;
        }
        case 400: {
          const responseBody = JSON.parse(res._body);
          if (this.tools.localStorageService.getOauthToken()) { // error POST/PUT

          } else if (responseBody.error_description && responseBody.error) { // connection
            switch (responseBody.error_description) {
              case 'Invalid refresh token':
                message = null;
                break;
              case 'The client credentials are invalid':
                message = 'Une erreur de configuration est survenue, veuillez vous rapprocher de votre gestionnaire. [CDCINV]';
                break;
              case 'Invalid username and password combination':
                message = 'Votre login et votre mot de passe ne concordent pas.';
                break;

              default:
                message = JSON.parse(res._body).error_description;
                break;
            }
            if (message) {
              this.afficheMessageError(message, "error")
              // this.tools.toast.createAdv({ message, type: 'error' });
            }

          } else if ('message' in responseBody) {
            this.afficheMessageError(responseBody.message, "error")
            // this.tools.toast.createAdv({ message: responseBody.message, type: 'error' });

          } else { // token expired
            // this.modelService.expire(this.lsService, this, this.app);
            this.afficheMessageError('La requête a échoué', "error")
            // this.tools.toast.createAdv({ message: 'La requête a échoué', type: 'error' });
          }
          this.loadingService.end();
          break;
        }
        case 500: {
          console.log(res);
          const doNothing = res.url.match(/\/api\/([a-zA-Z\-]+)\/([0-9]+)\/images\/([0-9]+)/g)
            || res.url.match(/\/api\/beneficiaires\/([0-9]+)\/photo/g) || res.url.includes('/validation');
          if (!doNothing) {
            this.afficheMessageError('Oups, une erreur est survenue, veuillez réessayer dans quelques minutes ou contacter votre administrateur.', "error")
            // this.tools.toast.createAdv({
            //   message: 'Oups, une erreur est survenue, veuillez réessayer dans quelques minutes ou contacter votre administrateur.',
            //   type: 'error'
            // });
            this.loadingService.end();
          }
          break;
        }
        case 503: {

          if (JSON.parse(res._body).message) {
            message = JSON.parse(res._body).message;
          } else {
            message = 'Site en maintenance';
          }

          this.modelService.logOut(this.app);
          this.afficheMessageError(message, "error")
          // this.tools.toast.createAdv({ message, type: 'error' });
          this.loadingService.end();
          break;
        }
      }
      return Observable.throw(res);
    };
  }

  private afficheMessageError(msg: string, type: string) {
    if (!this.isMsgErrorActif) {
      this.tools.toast.createAdv({
        message: msg,
        type: type
      });
      this.isMsgErrorActif = true;
      setTimeout(() => {
        this.isMsgErrorActif = false;
      }, 10000);
    }
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/httpInterceptor.service.ts